export const COINGECKO_TOKEN_ID_MAP = {
  BTC: "bitcoin",
  ETH: "ethereum",
  ATOM: "cosmos",
};
